import { module } from 'modujs';
import { html } from '../utils/environment'
import LocomotiveScroll from 'locomotive-scroll';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.scroll = new LocomotiveScroll({
            el: this.el,
            smooth: false
        });

        this.scroll.on('call', (func,way,obj,id) => {
            // Using modularJS
            this.call(func[0],{way,obj},func[1],func[2]);
        });

        this.scroll.on('scroll', (args) => {
            // if(args.scroll.y > 50) {
            //     html.classList.add('has-shrink-header')
            // } else {
            //     html.classList.remove('has-shrink-header')
            // }
        })

        this.loop = () => {
            if(html.scrollTop > 50) {
                html.classList.add('has-shrink-header');
            } else {
                html.classList.remove('has-shrink-header');
            }
            this.loopRAF = requestAnimationFrame(this.loop)
        }
        this.loop()

        const autoScrollTo = document.getElementById(this.getData('autoscrollto'))
        if(autoScrollTo) {
            this.scrollTo({ target: autoScrollTo })
        }
    }

    update() {
        if(this.scroll && this.scroll.update)
            this.scroll.update()
    }

    scrollTo(options) {
        if(!options.offset) options.offset = -150;
        this.scroll.scrollTo(options.target, options);
    }

    toggleLazy(args) {
        let src = this.getData('lazy', args.obj.el)
        if(src.length) {
            if(args.obj.el.tagName == "IMG") {
                args.obj.el.src = src
            } else {
                args.obj.el.style.backgroundImage = `url(${src})`
            }
            this.setData('lazy', '', args.obj.el)
        }
    }

    destroyLoop() {
        cancelAnimationFrame(this.loopRAF)
        html.classList.remove('has-shrink-header');
    }

    destroy() {
        this.destroyLoop()

        this.scroll.destroy();
    }
}
